import type { ReactNode } from "react";

interface MolduraDeAcessoProps {
  titulo: string;
  subtitulo?: ReactNode;
  /** Etiqueta acima do título, como a da entrada da equipe T4i. */
  selo?: ReactNode;
  /** Complemento da linha de direitos, no pé do cartão. */
  rodape?: ReactNode;
  children: ReactNode;
}

/**
 * Fundo, cartão e logotipo das telas de fora da sessão: login e recuperação
 * de senha. Estavam copiados em cada tela.
 */
export const MolduraDeAcesso = ({ titulo, subtitulo, selo, rodape, children }: MolduraDeAcessoProps) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center p-4 relative overflow-hidden">
    {/* Formas geométricas animadas de fundo */}
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-600/10 rounded-full animate-pulse"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-500/10 rounded-full animate-bounce"></div>
      <div className="absolute top-1/3 left-1/4 w-32 h-32 bg-blue-400/10 rounded-full animate-ping"></div>
    </div>

    <div className="w-full max-w-md bg-white/80 backdrop-blur-lg rounded-2xl shadow-2xl p-8 relative z-10 border border-white/20">
      <div className="text-center mb-8">
        {/* width/height são os do arquivo: com eles o navegador reserva o
            espaço antes de baixar o PNG e o cartão não pula. */}
        <img
          src="/T4I_logotipo_.png"
          alt="T4i Solutions"
          width={1021}
          height={584}
          className="h-16 w-auto mx-auto mb-6"
        />
        {selo && <div className="mb-3">{selo}</div>}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{titulo}</h1>
        {subtitulo && <p className="text-gray-600">{subtitulo}</p>}
      </div>

      {children}

      <div className="text-center text-xs text-gray-500 mt-6">
        © 2026 T4i Solutions - Todos os direitos reservados
        {rodape && <div className="mt-1">{rodape}</div>}
      </div>
    </div>
  </div>
);
